"use strict";

/* eslint-disable global-require */
var processInclude = require('base/util');
$(document).ready(function () {
//   processInclude(require('base/product/detail'));
  processInclude(require('./product/expressPayments'));
  processInclude(require('core/product/detail'));
  processInclude(require('core/product/wishlist'));
  processInclude(require('core/product/pralines'));
  require('core/product/imageSlider').init();
  require('core/product/stockNotification').init();
  require('core/product/personalisation').init();
});
